<template>
  <div
    :class="['profile-detail', { pointer: can && hasMinUsers }]"
    @click.prevent="toggleModal()"
    v-show="users"
  >
    <!-- <Show active users>-->
    <div class="users-wrapper">
      <Avatar
        class="media-object act-thumb circle"
        width="36"
        :name="firstPublicUser.name || firstPublicUser.email"
        :url="firstPublicUser.gravatar"
        v-b-tooltip="firstPublicUser.name || firstPublicUser.email"
      />
    </div>
    <!-- </Show active users>-->
    <Transition name="users-modal">
      <div
        class="users-modal show"
        v-if="showModal"
        @click.stop=""
      >
        <div class="form-group">
          <input
            class="form-control"
            type="text"
            placeholder="Encontrar usuário"
            v-model="query"
          >
        </div>
        <ul>
          <li
            class="pointer"
            v-for="maybeActive in usersByName"
            @click.prevent="toggleActive(maybeActive.id)"
          >
            <Avatar
              class="circle avatar"
              width="30"
              :name="maybeActive.name"
              :url="maybeActive.gravatar"
              :key="maybeActive.id"
            />            {{ maybeActive.name }}<i
              class="fa fa-check"
              v-if="isActive(maybeActive.id)"
            />
          </li>
          <li v-if="usersByName.length == 0">
            Nenhum usuário encontrado
          </li>
        </ul>
      </div>
    </Transition>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import User from '../user/Users.vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  extends: User,

  props: ['value'],

  methods: {
    toggleActive (id) {
      this.actives = [];
      this.addUser(id);
      this.$emit('input', id);
      this.toggleModal();
    },
  },
};
</script>
